import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useContext} from 'react';
import {useHistory} from 'react-router-dom';

import {useViewer} from '../../state/viewer/hooks';
import {
  PremiumFeatureTooltip,
  PremiumFeatureToolTipText,
  useIsAutomationEnabled,
} from '../../util/accounts/pricing';
import DocUrls from '../../util/doc_urls';
import * as urls from '../../util/urls';
import {useIsProjectReadOnly} from '../Registries/common/hooks';
import {ModelRegistryMigrationContext} from '../Registries/ModelRegistryMigration/ModelRegistryMigrationContextProvider';
import {AccountSelectorContext} from '../Search/SearchNav/AccountSelectorContextProvider';
import * as S from './ModelRegistryPageHeader.styles';
import {DEFAULT_PROJECT_NAME} from './utils';

type ModelRegistryPageHeaderProps = {
  onCreateModel?: () => void;
  onCreateAutomation?: () => void;
  entityName?: string;
  isPersonalEntity?: boolean;
};
export const ModelRegistryPageHeader = ({
  onCreateModel,
  isPersonalEntity,
  entityName,
  onCreateAutomation,
}: ModelRegistryPageHeaderProps) => {
  const viewer = useViewer();
  const isLoggedIn = !!viewer;
  const history = useHistory();
  const accessControlButtonDisabled = entityName == null;
  const {selectedAccount} = useContext(AccountSelectorContext);
  const hasAutomationAccess = useIsAutomationEnabled(selectedAccount);
  const {isProjectReadOnly} = useIsProjectReadOnly(
    // when this is undefined, it's the all-teams view, and we don't display the automations list
    // so just run a dummy query
    entityName ?? '',
    DEFAULT_PROJECT_NAME
  );
  // Model Registry Migration Context
  const {isMRReadOnly: readOnlyFromMRMigration} = useContext(
    ModelRegistryMigrationContext
  );

  const isTeamMRReadOnly = entityName != null && isProjectReadOnly; // not applicable in the all-teams view
  const readOnly = isTeamMRReadOnly || readOnlyFromMRMigration;
  return (
    <S.Header>
      <S.Title>Model registry</S.Title>
      <S.Spacer />
      <TargetBlank href={DocUrls.modelRegistry}>
        <Button
          size="large"
          variant="secondary"
          icon="documentation"
          style={{marginRight: '8px'}}>
          Documentation
        </Button>
      </TargetBlank>
      {isLoggedIn && (
        <>
          {!isPersonalEntity && (
            <Button
              size="large"
              variant="secondary"
              icon="settings"
              style={{marginRight: '8px'}}
              tooltip={
                accessControlButtonDisabled
                  ? 'Please select a team to visit this page'
                  : 'Access control'
              }
              onClick={() => {
                if (entityName != null) {
                  history.push(
                    urls.registryAccessControls(entityName, 'model')
                  );
                }
              }}
              disabled={accessControlButtonDisabled}
            />
          )}
          {entityName != null && !readOnly && (
            <Button
              className="mr-8"
              size="large"
              variant="secondary"
              icon="add-new"
              disabled={!hasAutomationAccess}
              tooltip={
                !hasAutomationAccess ? (
                  <PremiumFeatureToolTipText isPremiumFeatureDisabled={true} />
                ) : undefined
              }
              onClick={onCreateAutomation}>
              <>
                Create automation
                <PremiumFeatureTooltip
                  isPremiumFeatureDisabled={!hasAutomationAccess}
                />
              </>
            </Button>
          )}
          {!readOnly && (
            <Button
              className="create-collection"
              size="large"
              variant="primary"
              icon="add-new"
              onClick={() => {
                onCreateModel?.();
              }}>
              Create collection
            </Button>
          )}
        </>
      )}
    </S.Header>
  );
};
